import Vue from 'vue';
import "./theme/index.css";
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import "./assets/css/common.less";
import "./assets/css/fonts.css";
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false

Vue.use(ElementUI, { size: 'small', zIndex: 3000 });


Vue.mixin({
    methods: {
      uniDateFormat(input) {
        return input;
        // return input && dateUtil.format(new Date(input), 'yyyy-MM-dd HH:mm:ss');
      }
    },
  });

const vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')